<template>
  <div class="wrapper">
    <side-bar>
      <mobile-menu slot="content"></mobile-menu>
      <sidebar-link to="/scriba/dashboard">
        <i class="nc-icon nc-grid-45"></i>
        <p>Dashboard</p>
      </sidebar-link>
      <sidebar-link to="/scriba/receipts">
        <i class="nc-icon nc-money-coins"></i>
        <p>Receipts</p>
      </sidebar-link>
      <sidebar-link to="/scriba/user">
        <i class="nc-icon nc-circle-09"></i>
        <p>User Profile</p>
      </sidebar-link>

      <div v-if="settings.admin" class="link-group">
        <div class="group-title">Admin</div>

        <sidebar-link to="/scriba/admin/receipts">
          <i class="nc-icon nc-money-coins"></i>
          <p>Manage Receipts</p>
        </sidebar-link>
        <sidebar-link to="/scriba/admin/data-tools">
          <i class="nc-icon nc-money-coins"></i>
          <p>Data Tools</p>
        </sidebar-link>
      </div>

      <template slot="bottom-links">
        <sidebar-link to="/logout">
          <v-icon color="white">mdi-logout</v-icon>
          <p>Logout</p>
        </sidebar-link>
      </template>
    </side-bar>
    <div class="main-panel">
      <top-navbar></top-navbar>

      <dashboard-content @click="toggleSidebar">

      </dashboard-content>

      <content-footer></content-footer>
    </div>
  </div>
</template>
<style lang="scss">

</style>
<script>
import TopNavbar from './TopNavbar.vue';
import ContentFooter from './ContentFooter.vue';
import DashboardContent from './Content.vue';
import MobileMenu from './MobileMenu.vue';
import { settings, settings$ } from '../services/settings.util';
import { first } from 'rxjs';

export default {
  components: {
    TopNavbar,
    ContentFooter,
    DashboardContent,
    MobileMenu,
  },
  data: () => ({ settings }),

  created() {
    settings$.pipe(first()).subscribe((settings) => this.settings = settings);
  },

  mounted() {
  },
  methods: {
    toggleSidebar() {
      if (this.$sidebar.showSidebar) {
        this.$sidebar.displaySidebar(false);
      }
    },
  },
};

</script>
<style lang="scss">

.link-group {
  margin-top: 2rem;
  padding-top: 1rem;
  border-top: solid 2px #999999;
  position: relative;

  .group-title {
    position: absolute;
    background: #434343;
    display: inline-block;
    top: -1rem;
    left: 1rem;
    padding: 0 1rem;
  }
}
</style>
